import React from 'react'

import {
    StyledBreadcrumbContainer,
    StyledBreadcrumb,
    StyledChevron,
    StyledSevenChevron,
    StyledLink,
    StyledSpan,
    StyledPageTitle,
} from '../../navigation/Breadcrumb/Breadcrumb.styled'
import {
    SponsoredTopic,
    SponsoredTopicProps,
} from '../../advertising/SponsoredTopic/SponsoredTopic'
import { ThemedRender } from '../../__styling/themed-render'
import { ThemeMargins } from '../../__styling/settings/metrics'

export type LinkProps = {
    text: string
    href?: string
}

export interface BreadcrumbProps {
    items: LinkProps[]
    enableHeaderTag?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
}

export const Breadcrumb: React.FC<BreadcrumbProps & SponsoredTopicProps> = ({
    items,
    sponsor,
    enableHeaderTag,
    verticalSpacing,
}) => {
    if (!items || items.length === 0) {
        return null
    }
    const numberOfLevels = items.length

    function displayItemText(item: LinkProps) {
        const itemText = item.text.toLowerCase()

        if (itemText === 'sunrise') {
            return 'entertainment - sunrise'
        }

        if (itemText === 'the morning show') {
            return 'entertainment - the morning show'
        }

        return item.text
    }

    const breadcrumbs = () =>
        items.map((item, index) => {
            const isLast = index === numberOfLevels - 1

            //DPT3349 - Add topic breadcrumbs to Sunrise and Morning Show pages
            if (item.text.toLowerCase() === 'spotlight') {
                return null
            }

            const chevron = (
                <ThemedRender
                    thewest={() => <StyledChevron />}
                    perthnow={() => <StyledChevron />}
                    sevennews={() => <StyledSevenChevron />}
                />
            )

            const itemLink = item.href ? (
                <React.Fragment key={index}>
                    <StyledLink
                        enableHeaderTag={enableHeaderTag}
                        to={item.href}
                        isLast={isLast}
                    >
                        {displayItemText(item)}
                    </StyledLink>
                    {!isLast && chevron}
                </React.Fragment>
            ) : (
                <React.Fragment key={index}>
                    <StyledSpan isLink={false} isLast={isLast}>
                        {displayItemText(item)}
                    </StyledSpan>
                    {!isLast && chevron}
                </React.Fragment>
            )

            if (enableHeaderTag && isLast) {
                return <StyledPageTitle key={index}>{itemLink}</StyledPageTitle>
            } else {
                return <React.Fragment key={index}>{itemLink}</React.Fragment>
            }
        })
    return (
        <StyledBreadcrumbContainer verticalSpacing={verticalSpacing}>
            <StyledBreadcrumb>{breadcrumbs()}</StyledBreadcrumb>
            {sponsor && <SponsoredTopic sponsor={sponsor} />}
        </StyledBreadcrumbContainer>
    )
}
Breadcrumb.displayName = 'Breadcrumb'
